module.exports = __webpack_public_path__ + "img/Hypoxia-SCC_GSE144240.cc41f4b4.png";